import { useEffect } from 'react';
import { useAmplitude } from 'hooks/useAmplitude';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import { useOffers } from '../hooks/useOffers';
import { ChecksRequired } from './ChecksRequired/ChecksRequired';
import { OffersError } from './OffersError/OffersError';
import { OffersLoader } from './OffersLoader/OffersLoader';

export const ProductOffers = () => {
  const { trackEvent } = useAmplitude();

  const {
    isLoadingOffers,
    isRefetchingOffers,
    isLoadingState,
    offers,
    signupError,
    shouldRedirect,
    hasSignupDecision,
    isErrorChecked,
    setIsErrorChecked,
    isSecurityCheckRequired,
    handleRedirect,
  } = useOffers({ getOffersEnabled: true });

  useEffect(() => {
    trackEvent(AMPLITUDE_EVENTS.newApplicationProductOffersPending);
    setIsErrorChecked(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const hasDataAvailable =
      !isLoadingOffers &&
      !isRefetchingOffers &&
      isErrorChecked &&
      !signupError &&
      !isLoadingState &&
      !isSecurityCheckRequired;

    if (offers && hasDataAvailable) {
      handleRedirect(offers);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isLoadingOffers,
    isRefetchingOffers,
    offers,
    isErrorChecked,
    isLoadingState,
    isSecurityCheckRequired,
  ]);

  if (
    (!offers && !signupError) ||
    isLoadingOffers ||
    isRefetchingOffers ||
    (!hasSignupDecision && !signupError) ||
    shouldRedirect
  ) {
    return <OffersLoader />;
  }

  if (signupError) {
    return <OffersError error={signupError} />;
  }

  if (isSecurityCheckRequired) {
    return <ChecksRequired />;
  }

  // Show loader while being redirected to the trading history page if none of the above conditions are true.
  return <OffersLoader />;
};
